var map = {
	"./arg.svg": 2338,
	"./aus.svg": 2339,
	"./bel.svg": 2340,
	"./bra.svg": 2341,
	"./can.svg": 2342,
	"./cmr.svg": 2343,
	"./crc.svg": 2344,
	"./cro.svg": 2345,
	"./den.svg": 2346,
	"./ecu.svg": 2347,
	"./eng.svg": 2348,
	"./esp.svg": 2349,
	"./fra.svg": 2350,
	"./ger.svg": 2351,
	"./gha.svg": 2352,
	"./irn.svg": 2353,
	"./jpn.svg": 2354,
	"./kor.svg": 2355,
	"./ksa.svg": 2356,
	"./mar.svg": 2357,
	"./mex.svg": 2358,
	"./ned.svg": 2359,
	"./pol.svg": 2360,
	"./por.svg": 2361,
	"./qat.svg": 2362,
	"./sen.svg": 2363,
	"./srb.svg": 2364,
	"./sui.svg": 2365,
	"./tun.svg": 2366,
	"./uru.svg": 2367,
	"./usa.svg": 2368,
	"./wal.svg": 2369
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 131;